// extracted by mini-css-extract-plugin
module.exports = {"titleFilter":"index_titleFilter__sCQCy","input":"index_input__dEUul","suffix":"index_suffix__I30z7"};